// Icons (SVG)
// Drawer
import config from '../../config';
import GiftCardsSvg from '../../images/brand/icons/side-menu/gift-cards.svg';
import ContactUsSvg from '../../images/brand/icons/side-menu/help-contact.svg';
import InformationSvg from '../../images/brand/icons/side-menu/information.svg';
import MyAccountSvg from '../../images/brand/icons/side-menu/my-account.svg';
import {AppRoute} from '../../models/AppRoute';
import {AccountScreenAction} from '../../models/navigationTypes';
import AccountChooser from '../../screens/account/AccountChooser';
import AccountCommunicationsPreferencesScreen from '../../screens/account/AccountCommunicationsPreferencesScreen';
import AccountCreateScreen from '../../screens/account/AccountCreateScreen';
import AccountDeleteScreen from '../../screens/account/AccountDeleteScreen';
import AccountEmailVerificationScreen from '../../screens/account/AccountEmailVerificationScreen';
import AccountEntryScreen from '../../screens/account/AccountEntryScreen';
import AccountPhoneVerificationScreen from '../../screens/account/AccountPhoneVerificationScreen';
import AccountRewardsScreen from '../../screens/account/AccountRewardsScreen';
import AccountSuccessScreen from '../../screens/account/AccountSuccessScreen';
import LoginScreen from '../../screens/account/LoginScreen';
import PasswordReset from '../../screens/account/PasswordReset';
import PaymentMethodScreen from '../../screens/account/PaymentMethodScreen';
import {
  ACCOUNT_ACTION_CHOOSER,
  ACCOUNT_COMMUNICATIONS_PREFERENCES,
  ACCOUNT_REWARDS,
  CHANGE_PASSWORD,
  ACCOUNT_COLLECT_MISSING_DETAILS,
  CONTACT_US,
  CONTACT_US_SUBMIT_TICKET,
  DELETE_ACCOUNT,
  EDIT_ACCOUNT,
  GIFT_CARDS_HOW_TO_CHECK_BALANCE,
  GIFT_CARDS_HOW_TO_REDEEM,
  GIFT_CARDS_OPTIONS,
  GIFT_CARDS_TERMS_AND_CONDITIONS,
  INFORMATION,
  INFORMATION_CONTENT,
  LOGIN,
  NEW_ACCOUNT,
  ORDER_SCREEN,
  PAYMENT_METHOD,
  PROCESSING_ORDER,
  RESET_PASSWORD,
  STORE_NAME,
  STORE_SELECTION,
  VIEW_ORDER,
} from '../../screens/constants';
import GiftCardsCheckBalanceScreen from '../../screens/giftCards/balance/GiftCardsCheckBalanceScreen';
import GiftCardsHowToRedeemScreen from '../../screens/giftCards/GiftCardsHowToRedeemScreen';
import GiftCardsOptionsScreen from '../../screens/giftCards/GiftCardsOptionsScreen';
import GiftCardsTermsAndConditionsScreen from '../../screens/giftCards/GiftCardsTermsAndConditions';
import HelpContactScreen from '../../screens/helpContact/HelpContactScreen';
import HelpContactSubmitTicketScreen from '../../screens/helpContact/HelpContactSubmitTicketScreen';
import IFrameFullScreen3DS from '../../screens/IFrameFullScreen3DS';
import InformationContentScreen from '../../screens/information/InformationContentScreen';
import InformationScreen from '../../screens/information/InformationScreen';
import OrderProcessingScreen from '../../screens/OrderProcessingScreen';
import OrderViewScreen from '../../screens/recentOrders/OrderViewScreen';
import RecentOrderScreen from '../../screens/recentOrders/RecentOrderScreen';
import RewardsActivateTermsAndConditionsScreen from '../../screens/rewards/activate/RewardsActivateTermsAndConditionsScreen';
import RewardsActivateVerificationScreen from '../../screens/rewards/activate/RewardsActivateVerificationScreen';
import RewardsSuccess from '../../screens/rewards/Success';
import StoreSelectionScreen from '../../screens/storeSelection/StoreSelectionScreen';
import SuburbSelectionScreen from '../../screens/storeSelection/SuburbSelectionScreen';
import {drawerIcon} from '../components/DrawerIcon';
import {header} from '../components/Header';

import {
  commonDrawerRouteProps,
  commonNoTabOrDrawerRouteProps,
} from './commonRouteProps';
import {RouteSpec, RouteWithoutTargetStoreType, TargetStoreType} from './types';

const noTabOrDrawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.ACCOUNT_LOGIN,
    component: LoginScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: LOGIN,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_DETAIL,
    component: AccountCreateScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: EDIT_ACCOUNT,
    }),
    initialParams: {action: AccountScreenAction.UPDATE},
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_CREATE,
    component: AccountCreateScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: NEW_ACCOUNT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_DELETE,
    component: AccountDeleteScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: DELETE_ACCOUNT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_CHANGE_PASSWORD,
    component: AccountCreateScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: CHANGE_PASSWORD,
    }),
    initialParams: {action: AccountScreenAction.CHANGE_PASSWORD},
    ...commonNoTabOrDrawerRouteProps,
  }, 
  {
    name: AppRoute.ACCOUNT_COLLECT_MISSING_DETAILS,
    component: AccountCreateScreen,
    header: header({
      back: false,
      shop: false,
      filter: false,
      burger: false,
      search: false,
      blinkerMode: true,
      source: ACCOUNT_COLLECT_MISSING_DETAILS,
    }),
    initialParams: {action: AccountScreenAction.COLLECT_MISSING_DETAILS},
    ...commonNoTabOrDrawerRouteProps,
  }, 
  {
    name: AppRoute.ACCOUNT_PASSWORD_RESET,
    component: PasswordReset,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: RESET_PASSWORD,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_RECENT_ORDERS,
    component: RecentOrderScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: ORDER_SCREEN,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_ORDER_VIEW,
    component: OrderViewScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: VIEW_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_PAYMENT_METHOD,
    component: PaymentMethodScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: PAYMENT_METHOD,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CONTACT_US_SUBMIT_TICKET,
    component: HelpContactSubmitTicketScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: CONTACT_US_SUBMIT_TICKET,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.INFORMATION_CONTENT,
    component: InformationContentScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: INFORMATION_CONTENT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_PROCESSING,
    component: OrderProcessingScreen,
    header: header({
      back: false,
      filter: false,
      burger: true,
      search: false,
      source: PROCESSING_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.THREEDS_IFRAME_FULLSCREEN,
    component: IFrameFullScreen3DS,
    header: header({
      back: false,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  // These routes are also present in the Root Navigator (App.tsx)
  {
    name: AppRoute.MY_STORE_SUBURB_SELECTION,
    component: SuburbSelectionScreen,
    header: header({
      back: false,
      shop: true,
      filter: false,
      burger: false,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.MY_STORE_STORE_SELECTION,
    component: StoreSelectionScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: false,
      search: true,
      source: STORE_SELECTION,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.GIFT_CARDS_CHECK_BALANCE,
    component: GiftCardsCheckBalanceScreen,
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: GIFT_CARDS_HOW_TO_CHECK_BALANCE,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.GIFT_CARDS_HOW_TO_REDEEM,
    component: GiftCardsHowToRedeemScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: false,
      search: true,
      source: GIFT_CARDS_HOW_TO_REDEEM,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.GIFT_CARDS_TERMS_AND_CONDITIONS,
    component: GiftCardsTermsAndConditionsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: false,
      search: true,
      source: GIFT_CARDS_TERMS_AND_CONDITIONS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
];

if (config.FF_LOYALTY_ENABLED) {
  noTabOrDrawerRoutes.push({
    name: AppRoute.ACCOUNT_PHONE_VERIFICATION,
    component: AccountPhoneVerificationScreen,
    header: header({
      back: false,
      shop: false,
      filter: false,
      burger: false,
      search: false,
      blinkerMode: true,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
  noTabOrDrawerRoutes.push({
    name: AppRoute.ACCOUNT_EMAIL_VERIFICATION,
    component: AccountEmailVerificationScreen,
    header: header({
      back: false,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      blinkerMode: true,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
  noTabOrDrawerRoutes.push({
    name: AppRoute.ACCOUNT_SUCCESS,
    component: AccountSuccessScreen,
    header: header({
      back: false,
      shop: false,
      filter: false,
      burger: false,
      search: false,
      blinkerMode: true,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
  noTabOrDrawerRoutes.push({
    name: AppRoute.ACCOUNT_REWARDS,
    component: AccountRewardsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: ACCOUNT_REWARDS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
  noTabOrDrawerRoutes.push({
    name: AppRoute.ACCOUNT_COMMUNICATIONS_PREFERENCES,
    component: AccountCommunicationsPreferencesScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: ACCOUNT_COMMUNICATIONS_PREFERENCES,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
}

const drawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.ACCOUNT_NOT_LOGGED_IN,
    component: AccountEntryScreen,
    title: 'My Account & Sign in',
    icon: drawerIcon(MyAccountSvg),
    requiresLogout: true,
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: LOGIN,
    }),
    drawerSortOrder: 2,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.ACCOUNT_LOGGED_IN,
    component: AccountChooser,
    title: 'My Account',
    icon: drawerIcon(MyAccountSvg),
    requiresLogin: true,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: ACCOUNT_ACTION_CHOOSER,
    }),
    drawerSortOrder: 2,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.INFORMATION,
    component: InformationScreen,
    title: 'Information',
    icon: drawerIcon(InformationSvg),
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: INFORMATION,
    }),
    drawerSortOrder: 6,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.CONTACT_US,
    component: HelpContactScreen,
    title: 'Contact Us',
    icon: drawerIcon(ContactUsSvg),
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: CONTACT_US,
    }),
    drawerSortOrder: 7,
    ...commonDrawerRouteProps,
  },
];

if (config.FF_IS_GIFT_CARDS_ENABLED) {
  drawerRoutes.push({
    name: AppRoute.GIFT_CARDS_OPTIONS,
    component: GiftCardsOptionsScreen,
    title: 'Gift Cards',
    icon: drawerIcon(GiftCardsSvg),
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: GIFT_CARDS_OPTIONS,
    }),
    drawerSortOrder: 5,
    ...commonDrawerRouteProps,
  });
}

const allStoresAppRoutes: RouteSpec[] = [
  ...noTabOrDrawerRoutes,
  ...drawerRoutes,
].map(routeWithNoTargetStoreType => {
  const route: RouteSpec = {
    ...routeWithNoTargetStoreType,
    targetStoreType: TargetStoreType.All,
  };
  return route;
});

export default allStoresAppRoutes;
